export default __webpack_public_path__ + "static/2-8-0-0-a6ad4aa70ca2d35c4f98d33b3f022426.jpg";